<template>
	<div class="wrapper">
		<breadcrumbs></breadcrumbs>
		<div class="wrappers">
			<div class="mn">
				<div class="zhanzhuai-guide-tit mb15 cl">
					<div class="guide-topico cl">
						<img src="../../../assets/guide-topico1.png" alt="">
					</div>
					<div class="guide-name-c">
						<div class="guide-name">
							 <el-dropdown placement="bottom-start">
							  <div style="display: flex;align-items: center;">
								  <span class="el-dropdown-link">
								  	 TA的博客
								  </span>
								  <el-button v-if="listQuery.uid!=puid" type="text" @click="user_guanzhu">
									  <span :style="{color:guanzhu==true?'red':'#fff'}">
										  {{guanzhu==true?'取消关注':'关注TA'}}
									  </span>
								  </el-button>
							  </div>
							</el-dropdown>
						</div>
					</div>
				</div>
				<div class="zz_article_list box plr25 mb15 cl">
					<div class="list" v-for="(item,i) in list" @click="detail(item)" :key="i">
						<div class="zz_article_pic" v-if="item.imgurl">
							<img :src="item.imgurl" alt="">
						</div>
						<div class="zz_article_txt" style="height: 125px;">
							<div class="zz_atit cl">
								{{item.title}}
							</div>
							<div class="zz_article_meta cl">
								<div class="span01" style="margin-right: 10px;">{{item.nickname}}</div>
								发表于：{{item.createTime}}
		<!-- 						<div class="xg1" style="margin-left: 10px;">
									<div>|</div>
									<div class="xg101" style="margin-left: 10px;">编辑</div>
									<div>|</div>
									<div class="xg101" style="margin-left: 10px;">删除</div>
								</div> -->
							</div>
						</div>
					</div>
				</div>
				
				<!-- 分页 -->
				<div class="pagination-container">
				  <el-pagination
				    :current-page="listQuery.page"
				    :page-sizes="[10,20,30, 40]"
				    :page-size="listQuery.limit"
				    :total="total"
				    background layout="total, sizes, prev, pager, next, jumper"
				    @size-change="handleSizeChange"
				    @current-change="handleCurrentChange"
				  />
				</div>
				
			</div>
			
			<!--右边-->
			<div class="ri">
				<div class="zz_section_titles" @click="handlecreate(1,'')">
					发布博客
				</div>
				
				<div class="zz_jspc_pdiy box p25">
					<div class="zz_section_title" style="margin-bottom: 0px;">
						24小时热文
					</div>
					<div class="rewenlist" v-for="(item,i) in xiaoshi" @click="detail(item)"  :key="i">
						<div class="zz_express_pic">
							<span :class="[i==0?'zz_num1':i==1?'zz_num2':i==2?'zz_num3':'']">{{i+1}}</span>
							<img :src="item.imgurl" alt="">
						</div>
						<div class="zz_express_txt">
							<div class="hs">
								<div class="hss">
									{{item.title}}
								</div>
							</div>
							<span>{{item.createTime}}</span>
						</div>
					</div>
				</div>
				
				<div class="zz_jspc_pdiy box p25">
					<div class="zz_section_title">
						阅读推荐
					</div>
					<div class="yueduo">
						<div class="yueduos"  v-for="(item,i) in list" @click="detail(item)"  v-if="i<5" :key="i">
							<i></i>
							<div class="yueduos01">
								<div class="zz_recnews_title">{{item.title}}</div>
								<div class="zz_recnews_time">{{item.createTime}}</div>
							</div>
						</div>
					</div>
				</div>
				
			</div>
		</div>
		<save ref="savedata" @succ="succcreate"></save>
	</div>
</template>

<script>
	import { ta_boke_list,user_kaobo_save,user_boke_list } from "@/api/boke"
	import save from "./components/save.vue"
	import { getToken } from '@/utils/auth'
	import { user_look_kaibo,user_guanzhu } from "@/api/user"
	export default {
		components:{
			save
		},
		data(){
			return{
				listQuery:{
					page:1,
					limit:7,
					uid:''
				},
				list:[],
				total:0,
				loading:false,
				
				xiaoshi:[],//24小时热文
				puid:'',
				guanzhu:false,
			}
		},
		mounted(){
			document.title = "MetaBiz-TA的博客";
			this.listQuery.uid = this.$route.query.uid?this.$route.query.uid:''
			this.ta_boke_list();
			this.userlist();//24小时热门
		},
		methods:{
			handlecreate(type){
				//需要先判断一下是否登录
				if(getToken()){
					//判断是否有权限
					 const loading = this.$loading({
					          lock: true,
					          text: '请求中',
					          spinner: 'el-icon-loading',
					          background: 'rgba(0, 0, 0, 0.7)'
					        });
					user_look_kaibo({}).then(res=>{
						console.log("是否开博",res);
						loading.close();
						if(res.data && res.data.status==2){
							this.$refs.savedata.handlecreate(1,'');
						}else{
							this.$message.error("请到管理中心申请开博");
						}
					}).catch(()=>{
						loading.close();
						this.$message.error("暂无权限");
					})
				}else{
					loginEvent.$emit('loginDialogEvent')
				}
			},
			succcreate(id){
				this.ta_boke_list();
			},
			user_guanzhu(){
				const loading = this.$loading({
				  lock: true,
				  text: '操作中',
				  spinner: 'el-icon-loading',
				  background: 'rgba(0, 0, 0, 0.7)'
				});
				user_guanzhu({
					uid:this.listQuery.uid
				}).then(()=>{
					loading.close();
					this.$message.success("成功");
					this.ta_boke_list();
				}).catch(()=>{
					loading.close();
				})
			},
			ta_boke_list(){
				this.loading = true
				ta_boke_list(this.listQuery).then(res=>{
					this.loading = false
					console.log("博客列表",res.data);
					this.total = res.data.total
					this.list = res.data.list
					this.puid = res.data.puid
					this.guanzhu = res.data.guanzhu
				}).catch(()=>{
					this.loading = false
				})
			},
			detail(item){
				this.$router.push({
					path:"/bokedetail",
					query:{
						id:item.id
					}
				})
			},
			userlist(){
				user_boke_list({
					page:1,
					limit:6,
					show:'desc',
					imgurl:true
				}).then(res=>{
					console.log("24小时热门",res.data);
					this.xiaoshi = res.data.list
				})
			},
			//下一页上一页操作
			handleSizeChange(val) {//条数
			  this.listQuery.limit = val
			  this.ta_boke_list();
			},
			handleCurrentChange(val) {//列数
			  this.listQuery.page = val
			  this.ta_boke_list();
			},
		},
	}
</script>

<style lang="scss" scoped>
	.yueduo{
		border-left: 1px solid #EEEEEE;
		.yueduos{
			position: relative;
	        padding: 6px 0 6px 15px;
			cursor: pointer;
			.yueduos01{
				line-height: 24px;
				color: #999;
				.zz_recnews_title{
					font-size: 14px;
					color: #333;
					overflow: hidden;
				}
				.zz_recnews_title:hover{
					color: #FFA07A;
				}
				.zz_recnews_time{
					margin-bottom: 10px;
					font-size: 14px;
					font-style: inherit;
					font-family: Georgia;
				}
			}
			i{
			    width: 5px;
			    height: 5px;
			    background: #fff;
			    border-width: 1px;
			    border-color: #aaa;
			    border-style: solid;
			    border-radius: 100%;
			    position: absolute;
			    z-index: 1;
			    left: -4px;
			    top: 15px;	
			}
		}
		.yueduos:hover{
			i{
				background: #FFA07A;
				border-color: #FFA07A;
			}
		}
	}
	.zz_num1{
		background: #e1554e!important;
	}
	.zz_num2{
		background: #f3bf5a!important;
	}
	.zz_num3{
		background: #7586db!important;
	}
	.rewenlist:nth-child(1){
		padding: 0px;
	}
	.zhanzhuai-guide-tit{
		position: relative;
		width: 860px;
		height: 105px;
		.guide-name-c{
			position: absolute;
			float: left;
			top: 35px;
			left: 125px;
			width: 130px;
			height: 38px;
			line-height: 38px;
			color: #fff;
			cursor: pointer;
			.guide-name{
				
				    position: absolute;
				    top: 0;
				    font-weight: 700;
				    left: 0;
					.el-dropdown-link{
						width: 128px;
						font-size: 26px;
						    color: #fff;
							display: flex;
							align-items: center;
					}
			}
		}
		.guide-topico{
			img{
				width: 100%;
				height: 105px;
				object-fit: cover;
			}
		}
	}
	.rewenlist{
		height: 65px;
		padding: 20px 0;
		border-bottom: 1px solid #f0f0f0;
		cursor: pointer;
		.zz_express_txt{
			cursor: pointer;
			    height: 65px;
			    overflow: hidden;
				span{
					font-size: 12px;
					    color: #8590a6;
				}

				.hs{
					margin-bottom: 8px;
					    max-height: 40px;
					    text-overflow: ellipsis;
					    overflow: hidden;
					    -webkit-line-clamp: 2;
					.hss{
						line-height: 20px;
						    font-size: 14px;
						    color: #18191a;
						    font-weight: 400;
						    word-break: break-word;
					}
					.hss:hover{
						color: #FFA07A;
					}
				}
		}
		.zz_express_pic{
			position: relative;
			    float: left;
			    width: 100px;
			    height: 65px;
			    margin-right: 12px;
			    overflow: hidden;
				img{
					width: 100px;
					    height: 65px;
					    vertical-align: top
				}
			span{
				position: absolute;
				    top: 0;
				    left: 0;
				    height: 20px;
				    padding: 0 10px;
				    color: #fff;
				    font-size: 12px;
				    line-height: 20px;
				    opacity: .85;
				    background-color: #313B3D;
				    border-radius: 2px 0 0;
			}
		}
	}
	.zz_section_titles{
		width: 100%;
		    height: 50px;
		    line-height: 50px;
		    margin-bottom: 15px;
		    text-align: center;
		    border-radius: 4px;
		    background: #fc7247;
			color: #fff;
			font-size: 15px;
			text-align: center;
			cursor: pointer;
	}
	.zz_article_list{
		
		.list{
			padding: 25px 0;
			background: #fff;
			transition: all 0.2s ease-in;
			border-bottom: 1px solid #F3F5F7;
			display: flex;
			align-items: center;
			cursor: pointer;
			.zz_article_meta{
				height: 25px;
				margin-top: 10px;
				color: #999;
				font-size: 12px;
				display: flex;
				align-items: center;
				.span01{
					color: #ee2e3d;
					margin-right: 3px;
					font-size: 12px;
					display: flex;
					align-items: center;
				}
				.xg1{
					color: #999!important;
					font-size: 12px;
					display: flex;
					align-items: center;
					.xg101{
						margin-right: 3px;
						font-size: 12px;
					}
				}
			}
			.zz_atit:hover{
				color: red;
			}
			.zz_article_pic{

				.zz_atit{
					width: auto;
					    height: auto;
					    line-height: 24px;
					    font-size: 18px;
					    font-weight: 700;
						color: #333;
				}
				    position: relative;
				    float: left;
				    width: 180px;
				    height: 125px;
				    margin-right: 15px;
				    overflow: hidden;
				    display: block;
					img{
						width: 180px;
						    height: 125px;
						    border-radius: 4px;
					}
			}
		}
	}
	.zz_article_top{
		position: relative;
		height: 75px;
		line-height: 75px;
		font-weight: normal;
		overflow: hidden;
		font-size: 30px;
		font-weight: normal;
		margin-bottom: 15px;
		span{
			display: block;
			padding-left: 25px;
		}
	}
	.wrapper{
		width: 1200px;
		margin: 0 auto;
		padding-top: 30px;
		.wrappers{
			width: 100%;
			display: flex;
			.mn{
				width: 860px;
				margin-bottom: 10px;
			}
			.ri{
				width: 325px;
				margin-left: auto;
				margin-bottom: 10px;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/luntan/boke/taboke.vue